import React from "react";

export default function CollectionListItem({ children, onClick }) {
  return (
    <li
      onClick={onClick}
      className="flex items-center justify-center shadow p-3 mt-3 cursor-pointer h-full w-full"
    >
      {children}
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/CollectionListItem/CollectionListItem.js